import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
// Component is currently in BETA mode.
// Read more: terra.vts.com/process/overview#beta
import classNames from "classnames";
import { Fragment } from "react";
import { cloneElement, useRef, useState } from "react";
import { offset, flip, shift, autoUpdate, useFloating, useHover, useInteractions, useRole, useDismiss, useClick, FloatingFocusManager, safePolygon, FloatingPortal, useListNavigation, } from "@floating-ui/react";
import { MenuItem } from "./MenuItem";
import { Typography } from "../Typography";
import { ThemeProviderContext } from "../ThemeProvider";
export const Menu = ({ triggerAction = "click", trigger, items, placement = "bottom", className = "", testId, }) => {
    const listRef = useRef([]);
    const [isOpen, setIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);
    const { x, y, reference, floating, strategy, context } = useFloating({
        whileElementsMounted: autoUpdate,
        open: isOpen,
        onOpenChange: setIsOpen,
        strategy: "fixed",
        placement: placement,
        middleware: [offset(4), flip(), shift()],
    });
    const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([
        useClick(context, { enabled: triggerAction === "click" }),
        useRole(context),
        useDismiss(context),
        useHover(context, {
            enabled: triggerAction === "hover",
            handleClose: safePolygon(),
        }),
        useListNavigation(context, {
            listRef,
            activeIndex,
            onNavigate: setActiveIndex,
            loop: true,
            focusItemOnHover: false,
        }),
    ]);
    const renderMenuItem = (item, index) => {
        return (_createElement(MenuItem, Object.assign({}, item, { key: `menuitem-${index}`, itemProps: getItemProps({
                ref(node) {
                    listRef.current[index] = node;
                },
            }), onClick: () => {
                setIsOpen(false);
            } })));
    };
    let optionIndex = 0;
    if (typeof window === "undefined") {
        return null;
    }
    return (_jsx(ThemeProviderContext.Consumer, { children: ({ menuZIndex }) => (_jsxs(_Fragment, { children: [cloneElement(trigger, getReferenceProps(Object.assign(Object.assign({ ref: reference }, trigger.props), { testId }))), _jsx(FloatingPortal, { root: document.body, children: isOpen && (_jsx(FloatingFocusManager, { context: context, children: _jsx("div", Object.assign({}, getFloatingProps({
                            className: classNames("rounded drop-shadow dark:drop-shadow-dark bg-background-primary dark:bg-background-tertiary-darkmode dark:border dark:border-border-subdued-darkmode focus:outline-2 overflow-hidden"),
                            ref: floating,
                            style: {
                                position: strategy,
                                top: y !== null && y !== void 0 ? y : "",
                                left: x !== null && x !== void 0 ? x : "",
                                zIndex: menuZIndex,
                            },
                        }), { children: _jsx("ul", { className: className, children: items.map((item) => {
                                    if ("items" in item) {
                                        return (_jsxs(Fragment, { children: [_jsx("div", { className: "border-b border-b-border-subdued dark:border-b-border-subdued-darkmode first:border-0" }), _jsxs("div", { style: { overflowWrap: "anywhere" }, "aria-label": item.label, children: [item.label && (_jsx(Typography, { variant: "body-small-emphasis", color: "text-primary", className: "px-1 pt-0.75 pb-0.25", children: item.label })), item.items.map((item) => {
                                                            return renderMenuItem(item, optionIndex++);
                                                        })] })] }, item.label));
                                    }
                                    else {
                                        return renderMenuItem(item, optionIndex++);
                                    }
                                }) }) })) })) })] })) }));
};
//# sourceMappingURL=Menu.js.map